import Head from 'next/head';
import AliceCarousel from 'react-alice-carousel';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';

import { eventGtag } from '#app/hooks/eventGtag';
import Layout from '#layout/index';
import { ButtonComponentVacation } from '#atoms/index';
import { OurValues, SectionAboutUs } from '#components/index';
import { useUserContext } from '#hooks/index';
import { canonicalURL } from '#helpers/canonical-url';

// Dynamic Components
const DynamicJumbutronUpd = dynamic(() =>
  import('../components/LearningPathAndCourse/JumbutronUpd/jumbutronUpd')
);

const UsPage = () => {
  const router = useRouter();
  const { data: userData } = useUserContext();
  const variant = 'ruta';

  const items = [
    '/about-us/image1.webp',
    '/about-us/image2.webp',
    '/about-us/image3.webp',
    '/about-us/image4.webp'
  ].map((item, i) => (
    <div tabIndex={0} key={i}>
      <img src={item} alt={`Imagen ${i} | Crack The Code`} />
    </div>
  ));

  return (
    <>
      <Head>
        <title>Acerca de Nosotros | Crack The Code</title>
        <meta
          name="description"
          content="Somos una academia online que empodera a niños y jóvenes a través del código y la tecnología ¡Conoce más sobre nosotros y nuestros cursos!"
        />
        <link rel="canonical" href={canonicalURL(router)} />
      </Head>
      <Layout mainType="full_variant">
        <div className="about-us">
          <DynamicJumbutronUpd
            variant={variant}
            title="El lenguaje del futuro"
            mainColor="#000000"
            description="Creamos oportunidades a través del código, la programación y tecnología para niños, niñas y jóvenes de Latinoamérica."
            imgDesk="/about-us/jumbutron-ours.webp"
            firstButton={
              <ButtonComponentVacation
                description="Contáctanos"
                mainColor="#000000"
                width="180px"
                variantButton="contained"
                download={false}
                external={true}
                onClick={() => eventGtag('contactanos_nosotros', userData)}
                href={`https://wa.me/17867892469?text=¡Hola! Me gustaría obtener más información de Crack The Code.`}
              />
            }
          />

          {/* Our story */}
          <section className="about-us__our-story">
            <h2 className="about-us__our-story-title about-us__our-story-title--bold">
              Nuestra historia
            </h2>
            <div className="about-us__our-story-container">
              <div className="about-us__first-section-story">
                <p className="about-us__our-story-paragraph">
                  <span className="about-us__our-story-paragraph--bold">
                    Crack The Code
                  </span>{' '}
                  nace a partir de la falta de{' '}
                  <span className="about-us__our-story-paragraph--bold">
                    enfoque en programación de las escuelas,
                  </span>{' '}
                  junto con el propósito de brindar este{' '}
                  <span className="about-us__our-story-paragraph--bold">
                    conocimiento a niños, niñas y adolescentes.
                  </span>
                </p>
              </div>
              <div className="about-us__second-section-story">
                <img src="/about-us/our-story.webp" alt="img" />
              </div>
            </div>
          </section>

          {/* Our Values */}
          <OurValues />

          {/* Abous us */}
          <SectionAboutUs
            title="Nuestra Propuesta"
            description={
              <>
                Queremos que nuestros estudiantes <b>aprendan mientras se divierten,</b>{' '}
                por esto creamos una <b>experiencia lúdica</b> diseñada especialmente para
                las edades de los estudiantes. <br />
                <br /> Enseñamos programación con <b>herramientas basadas en juego</b>y
                una metodología que busca que los estudiantes{' '}
                <b>resuelvan problemas por sí mismos.</b>{' '}
              </>
            }
            image="/business/developer-children-desktop.png"
            order={-1}
          />
        </div>

        <section className="about-us__alliance-companies">
          <div className="about-us__bg-deg-white"></div>
          <div className="about-us__bg-deg-pink"></div>
          <img src="/banner-landing-cursos.webp" alt="img" />
          {/* <p className="about-us__alliance-description">
            Financiamos y lideramos iniciativas sociales y becas a través de alianzas con
            otras empresas.
          </p> */}
        </section>

        <section
          className="about-us__carousel"
          onClick={() => eventGtag('photo_sliders_nosotros', userData)}
        >
          <AliceCarousel
            items={items}
            infinite
            animationDuration={200}
            autoWidth
            mouseTracking
            touchTracking
          />
        </section>
        <br />
      </Layout>
    </>
  );
};

export default UsPage;
